import gql from "graphql-tag";

export const TEAMS_MApp_ANCHORS = gql`
  query reportingTeamsMAppAnchors($includingManager: Boolean) {
    reportingTeamsMAppAnchors(includingManager: $includingManager)
  }
`;
